import EmptyResult from 'components/others/EmptyResult';
import UsersTableRow from './UsersTableRow';
import type { FetchUsersFn } from './types';
import type { UserType } from '@econtractor/types';

interface UsersTableBodyProps {
    usersList: UserType[];
    setShowSpinner: (value: boolean) => void;
    fetchUsers: FetchUsersFn;
    setShowUserCard: (userId: number | false) => void;
    showRole: boolean;
    showTeam: boolean;
    showAdmin: boolean;
}

const UsersTableBody = ({
    usersList,
    setShowSpinner,
    fetchUsers,
    setShowUserCard,
    showRole,
    showTeam,
    showAdmin,
}: UsersTableBodyProps) => {
    const colSpan = 3 + (showRole ? 1 : 0) + (showTeam ? 1 : 0) + (showAdmin ? 1 : 0);

    return (
        <tbody>
            {usersList?.length > 0 &&
                usersList.map((user) => (
                    <UsersTableRow
                        key={user.userEmail}
                        setShowSpinner={setShowSpinner}
                        user={user}
                        setShowUserCard={setShowUserCard}
                        fetchUsers={fetchUsers}
                        showRole={showRole}
                        showTeam={showTeam}
                        showAdmin={showAdmin}
                    />
                ))}

            {usersList.length === 0 && (
                <tr>
                    <td colSpan={colSpan}>
                        <EmptyResult />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default UsersTableBody;
